import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../../consts'
import {uploadSalesForecast, salesForecastQueryKeys} from '../backend'

type UploadSalesForecastParams = Parameters<typeof uploadSalesForecast>[0]

export const useUploadSalesForecast = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const raiseError = useErrorHandler()
  const queryClient = useQueryClient()

  return useMutation<void, AxiosError, UploadSalesForecastParams>({
    mutationFn: uploadSalesForecast,
    mutationKey: ['uploadSalesForecast'],
    onError: (error) => {
      const message = (error.response?.data as {message?: string})?.message
      if (message) {
        spawnErrorToast(message)
      } else {
        raiseError(error)
      }
    },
    onSuccess: () => {
      spawnSuccessToast(t('success.uploadSalesForecast'))
    },
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: [salesForecastQueryKeys.materialDemand]
      })
    }
  })
}
